import React from 'react';
import {Route, Router} from 'react-router';

import {
  Breakpoints,
  Container,
  IntegratorRoot,
  Layout,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import {
  Content,
  FaContentServiceV1,
} from '@volkswagen-onehub/fa-content-service';
import {FeatureAppLoader} from '@feature-hub/react';
import {History} from 'history';

import {appsCommonsJS, appsUMD} from './app-constants';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from './feature-app-helpers';
import {ModelOverviewIntegratorOptions} from './create-options-from-query-params';
import Ngw6AppRender from './components/ngw6-app-render';

export interface IntegratorProps extends ModelOverviewIntegratorOptions {
  readonly history: History;
}

export function Integrator({
  baseUrl,
  history,
  ssr,
  featureAppName = 'default',
  ...props
}: IntegratorProps): JSX.Element {
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  return (
    <IntegratorRoot>
      <ThemeProvider theme="main">
        <Layout
          appearance={{
            [Breakpoints.default]: [
              {name: '.', columns: 0},
              {name: 'a', columns: 24},
              {name: '.', columns: 0},
            ],
            [Breakpoints.b1600]: [
              {name: '.', columns: 2},
              {name: 'a', columns: 20},
              {name: '.', columns: 2},
            ],
          }}
          allowOverflowingContent
        >
          <Container wrap="always">
            <Router history={history}>
              <Route
                path="/"
                render={() => (
                  <FeatureAppLoader
                    featureAppId="storystream"
                    baseUrl={baseUrl}
                    src={appsUMD[featureAppName]}
                    serverSrc={ssr ? appsCommonsJS[featureAppName] : undefined}
                    config={featureAppConfig}
                    beforeCreate={({featureServices}) => {
                      const content: Content =
                        contentFeatureAppMap[featureAppName];

                      if (content) {
                        (
                          featureServices[
                            'fa-content-service'
                          ] as FaContentServiceV1
                        ).content = content;
                      }
                    }}
                  />
                )}
              />
              <Route
                path="/application-render/:appId"
                render={() => (
                  <Ngw6AppRender isSsr={ssr} baseUrl={baseUrl} {...props} />
                )}
              />
            </Router>
          </Container>
        </Layout>
      </ThemeProvider>
    </IntegratorRoot>
  );
}
